import { injectable, inject } from 'tsyringe';
import { OWWindow, OWWindowScreenAnchor } from '../../odk-ts';
import { LoggerService } from '../../shared/services/logger.service';
import {
  kDITokenOwTesterWindow,
  kDITokenPromotionWindowScreenAnchor,
} from '../constants';
import {
  kNameOfPromotionWindowManagerService,
  IPromotionWindowManagerService,
} from '../interfaces/promotion-window-manager-service.interface';
import {
  ITesterWindowManagerServiceDelegate,
  kNameOfTesterWindowManagerService,
  ITesterWindowManagerService,
} from '../interfaces/tester-window-manager-service.interface';
import { Game } from '../models/game.model';
import { Promotion } from '../models/promotion.model';

// -----------------------------------------------------------------------------
@injectable()
export class TesterWindow implements ITesterWindowManagerServiceDelegate {
  private readonly logger = LoggerService.getCategory('TesterWindow');
  // ---------------------------------------------------------------------------

  public constructor(
    @inject(kNameOfPromotionWindowManagerService)
    private readonly promotionWinManager: IPromotionWindowManagerService,
    @inject(kNameOfTesterWindowManagerService)
    private readonly testerWindowManagerService: ITesterWindowManagerService,
    @inject(kDITokenOwTesterWindow)
    private readonly owWindow: OWWindow,
    @inject(kDITokenPromotionWindowScreenAnchor)
    private readonly owWindowScreenAnchor: OWWindowScreenAnchor,
  ) {}

  // ---------------------------------------------------------------------------
  async show() {
    this.testerWindowManagerService.addListener(this);
    this.owWindow.restore();
  }

  // ---------------------------------------------------------------------------
  // TesterWindowManagerServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  async onTestingPromotionSet(
    game: Game,
    promotion: Promotion,
    useDevEnv: string,
  ) {
    this.logger.info(`Showing promotion ${game.id}, ${promotion.id}`);
    const isShown = await this.promotionWinManager.isPromotionShown();
    this.testerWindowManagerService.promotionAlreadyRunning(isShown);
    if (!isShown) {
      this.promotionWinManager.show(game.id, promotion.id, promotion.type, true, useDevEnv);
      return true;
    }

    this.logger.info(
      'Promotions window is Open, ' +
        '  unable to load new promotion until window is closed.',
    );

    return false;
  }

  // ---------------------------------------------------------------------------
  // PromotionWindowManagerServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  closePromotionWindow() {
    this.owWindowScreenAnchor.stop();
  }
}
